/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

export const progressBarVariantForPasswordStrength = (passwordStrength: number): string => {
	switch (passwordStrength) {
		case 2:
			return 'warning';
		case 3:
			return 'info';
		case 4:
			return 'success';
		case 0:
		case 1:
		default:
			return 'danger';
	}
};

export const passwordStrengthText = (passwordStrength: number): string => {
	switch (passwordStrength) {
		case 0:
			return 'Slecht';
		case 1:
			return 'Zwak';
		case 2:
			return 'Normaal';
		case 3:
			return 'Goed';
		case 4:
			return 'Sterk';
		default:
			return 'Slecht';
	}
};
